import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/cube-volume-calculator',
  component: () => import('../../routes/CubeVolumeCalculator.svelte'),
  card: {
    id: 'cube-volume-calculator',
    title: 'Cube Volume Calculator',
    description: 'Calculate the volume, surface area, diagonal, and more of a cube from its side length.',
    icon: 'cube',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/cube-volume-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Cube Volume Calculator – Volume, Surface Area & Diagonal',
    description:
      'Free cube volume calculator to find volume, total surface area, lateral surface area, face area, and space diagonal from side length. Includes formulas and step-by-step results.',
  },
};

export default meta;
